import * as ActionTypes from './ActionTypes';

const initialState = {
    open: false,
    fixedMenu: false,
    atsCollapse: false,
    atsManageCollapse: false,
    atsReportCollapse: false,
    lmsCollapse: false,
    EmployeeCollapse: false,
    financeCollapse: false,
    visitorsCollapse: false,
    canteenCollapse: false,
    expenseCollapse : false,
    myfinanceCollapse: false,
    settingCollapse: false,
    selectedMenuPath: '',
    activeMenus: [],
    selectedMenu: ''
};

const menuSectionMap = {
    "Employee": "employee",
    "Employee Bulk Upload": "employee",
    "Asset Management": "employee",
    "Tax Declaration": "myfinance",
    "Reports ": "myfinance",
    "PayConfig": "finance",
    "PayEntry": "finance",
    "PayRun" : "finance",
    // "Employee Time": "finance",
    "PayReports": "finance",
    "PayInsights": "finance",
    "PayECMS" : "finance",
    "Team Tax Approval": "finance",
    "ATS Dashboard": "ats",
    "Tasks": "ats",
    "Hiring Request": "ats",
    "Job Dashboard": "ats",
    "Candidate": "ats",
    "Invoice": "ats",
    "Agreements": "ats",
    "Employee Onboarding": "ats",
    "Add Users": "user",
    "Add Client": "user",
    "Add Group Organisation": "user",
    "Add Hiring Partner": "user",
    "Dashboard": "report",
    "Operational Reports": "report",
    "Revenue": "report",
    "LMS Dashboard": "lms",
    "My Timesheet": "lms",
    "Team": "lms",
    "Team Time": "lms",
    "Time Bulk Upload": "lms",
    "Holidays": "lms",
    "Quick Setup": "settings",
    "General": "settings",
    "Finance": "settings",
    "ATS": "settings",
    "Subscription": "settings",
    "Roles & Access": "settings",
    "Visitor Entry" : "visitors",
    'Pre-registration': "visitors",
    "Report": "visitors",
    "Dashboard ": "visitors",
    "Visitor Management" : "settings",
    "My Expenses" : "expenses",
    "Team Expenses" : "expenses",
    "Expense Management" : "settings",
    "Performance Management": "settings",
    "Token Config": "canteen",
    "Canteen Entry": "canteen",
    "Canteen Management": "settings"
};
const menuRelationships = {
    atsCollapse: ['atsManageCollapse', 'atsReportCollapse'],
};

const getActiveMenus = (selectedMenu) => {
    const section = menuSectionMap[selectedMenu];
    if (!section) return [];
    const sectionToMenuMap = {
        'employee': ['EmployeeCollapse'],
        'visitors': ['visitorsCollapse'],
        'canteen': ['canteenCollapse'],
        "expenses": ["expenseCollapse"],
        'myfinance': ['myfinanceCollapse'],
        'finance': ['financeCollapse'],
        'ats': ['atsCollapse'],
        'lms': ['lmsCollapse'],
        'settings': ['settingCollapse'],
        'user': ['atsManageCollapse'],
        'report': ['atsReportCollapse'],
    };
    return sectionToMenuMap[section] || [];
};
const findParentMenu = (childMenu) => {
    for (const [parent, children] of Object.entries(menuRelationships)) {
        if (children.includes(childMenu)) {
            return parent;
        }
    }
    return null;
};
const preserveActiveMenus = (state, menuToToggle) => {
    const newState = { ...state };
    const parentMenu = findParentMenu(menuToToggle);
    newState[menuToToggle] = !state[menuToToggle];
    if (parentMenu && newState[menuToToggle] === true) {
        newState[parentMenu] = true;
    }
    if (menuRelationships[menuToToggle] && newState[menuToToggle] === false) {
        menuRelationships[menuToToggle].forEach(childMenu => {
            newState[childMenu] = false;
        });
    }
    const activeMenus = getActiveMenus(state.selectedMenu);
    if (activeMenus.includes("settingCollapse") && menuToToggle !== "settingCollapse" && state["settingCollapse"] === false) {
        newState["settingCollapse"] = false;
    } else {
        activeMenus.forEach(menu => {
            if (menu !== menuToToggle && menu !== parentMenu) {
                newState[menu] = true;
            }
        });
    }
    return newState;
};

const MenuReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.MOBILE_MENU:
            return {
                ...state,
                isMobile: action.payload
            };

        case ActionTypes.FIXED_MENU_OPEN:
            return {
                ...state,
                open: true,
                fixedMenu: true
            };

        case ActionTypes.FIXED_MENU_CLOSE:
            return {
                ...state,
                open: false,
                fixedMenu: false
            };

        case ActionTypes.OPEN_MENU:
            return {
                ...state,
                open: true
            };

        case ActionTypes.CLOSE_MENU:
            return {
                ...state,
                open: false
            };

        case ActionTypes.ATS_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'atsCollapse')
            };

        case ActionTypes.ATS_COLLAPSE_SUB_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'atsManageCollapse')
            };

        case ActionTypes.ATS_REPORT_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'atsReportCollapse')
            };

        case ActionTypes.LMS_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'lmsCollapse')
            };

        case ActionTypes.EMPLOYEE_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'EmployeeCollapse')
            };
        case ActionTypes.FINACNE_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'financeCollapse')
            };

        case ActionTypes.MY_FINACNE_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'myfinanceCollapse')
            };
        case ActionTypes.VISITORS_MANAGEMENT_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'visitorsCollapse')
            };
        case ActionTypes.CANTEEN_MANAGEMENT_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'canteenCollapse')
            };
        case ActionTypes.EXPENSE_MANAGEMENT_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'expenseCollapse')
            };
        case ActionTypes.SETTINGS_COLLAPSE_MENU:
            return {
                ...state,
                ...preserveActiveMenus(state, 'settingCollapse')
            };

        case ActionTypes.ATS_MENU_HEADING: {
            const newHeading = action?.params?.heading;
            const section = menuSectionMap[newHeading] || null;
            const updatedState = {
                ...state,
                selectedMenu: newHeading,
                MenuHeading: newHeading,
                atsCollapse: false,
                lmsCollapse: false,
                EmployeeCollapse: false,
                financeCollapse: false,
                myfinanceCollapse: false,
                settingCollapse: false,
                atsManageCollapse: false,
                atsReportCollapse: false,
                visitorsCollapse: false,
                canteenCollapse: false,
                expenseCollapse: false,

            };
            if (section === "ats") updatedState.atsCollapse = true;
            else if (section === "lms") updatedState.lmsCollapse = true;
            else if (section === "employee") updatedState.EmployeeCollapse = true;
            else if (section === "finance") updatedState.financeCollapse = true;
            else if (section === "visitors") updatedState.visitorsCollapse = true;
            else if (section === "canteen") updatedState.canteenCollapse = true;
            else if (section === "expenses") updatedState.expenseCollapse = true;
            else if (section === "myfinance") updatedState.myfinanceCollapse = true;
            else if (section === "settings") updatedState.settingCollapse = true;
            else if (section === "user") {
                updatedState.atsCollapse = true;
                updatedState.atsManageCollapse = true;
            }
            else if (section === "report") {
                updatedState.atsCollapse = true;
                updatedState.atsReportCollapse = true;
            }
            return updatedState;
        }
        default:
            return state;
    }
};

export default MenuReducer;